// Phase II · Wave E.1c.4 · TD6 · M14 legacy feature flag.
//
// Single source of truth for the "legacy M14 cookie / localStorage"
// surface. The ``glms_lang`` dual-write surface (M14) was shipped
// alongside Wave D's canonical ``glms_locale`` as a 30-day migration
// shim in Wave D.6b. The window has elapsed · the dual-write is now
// OFF by default. All call-sites gate the legacy writes/reads behind
// ``M14_LEGACY_ENABLED``.
//
// Enabling (rollback / emergency re-arm) · set
// ``window.__GLMS_M14_LEGACY_ENABLED__ = true`` BEFORE React mounts
// (e.g. inject into ``index.html``) · the module is pure read, no
// cache, so the override is picked up on every call.
//
// Design notes
// ------------
// * No build-time env dependency · the override is runtime-only so a
//   rollback does not need a frontend redeploy (just a header or
//   script-tag flip).
// * Default ``false`` encodes the post-D.6b policy: M14 legacy writes
//   are no-ops; reads fall back gracefully to Accept-Language.
export function isM14LegacyEnabled() {
    try {
        if (typeof window !== "undefined"
                && window.__GLMS_M14_LEGACY_ENABLED__ === true) {
            return true;
        }
    } catch (_) { /* SSR · ignore */ }
    return false;
}
